// extracted by mini-css-extract-plugin
module.exports = {"header":"DeviceGroupPage_header__20XsP","deviceGroupCreateBtn":"DeviceGroupPage_deviceGroupCreateBtn__1CjKN","title":"DeviceGroupPage_title__3nPr7"};